<h3>{{title}}: {{displayQuery}}</h3>
<div>
    <a routerLink="/search-repo" routerLinkActive="active">
        <button>Search Repositories</button>
    </a>
    <a routerLink="/" routerLinkActive="active">
        <button>Home</button>
    </a>
</div>
<form (ngSubmit)="sendQuery()" [formGroup]="form">
    <div *ngFor="let key of modelKeys">
       {{key}}: <input placeholder="Enter {{key}} Here" formControlName="{{key}}" />
    </div>
    <button type="submit" [disabled]="!form.valid">Submit</button>
</form>

<div *ngIf="searchResults; then thenBlock else elseBlock"></div>
<ng-template #thenBlock><h3 class="total">Total results: {{searchResults.total_count}}</h3>
    <ul class="list">
        <li [ngClass]="{'bg-even' : (i%2 === 0)}" 
            class="list_item" 
            *ngFor="let result of searchResults.items; index as i;">
            <a [href]="result.html_url">
                <img class="avatar" [src]="result.avatar_url" /> 
                <h1 class="title">{{result.login | uppercase}}</h1>
            </a>
            <div class="description">
                <small>                    
                    <a [href]="result.followers_url"><i class="far fa-address-book"> followers</i></a> &nbsp;
                    <a [href]="result.subscriptions_url"><i class="far fa-bell"> subscriptions</i></a> &nbsp;
                    <a [href]="result.organizations_url"><i class="far fa-building"> organization</i></a> &nbsp;
                    <a [href]="result.repos_url"><i class="fas fa-journal-whills"> Repositories</i></a> &nbsp;
                    <a [href]="result.received_events_url"><i class="fas fa-hands"> Contributions</i></a>
                </small>
            </div>
        </li>
    </ul>
</ng-template>
<ng-template #elseBlock>Loading...</ng-template>